import logo from './logo.svg';
import './App.css';
import { hooks, metaMask } from './web3/metamask'
import { useEffect, useState } from 'react';
import { getFaucetSignature, getNonce } from './web3/axios';
import { useAirdropVerify } from './web3/AirdropVerify/useAirdropVerify';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
const { useAccount, useProvider, useChainId } = hooks;
function App() {
  const provider = useProvider();
  const address = useAccount()
  const [nonce, setNonce] = useState('')
  const [splitResult, setSplit] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { getAirdrop, getIsVerified } = useAirdropVerify()
  const [conrrected, setCorrect] = useState(false)
  const chainId = useChainId()
  useEffect(() => {
    async function fetchInfomation() {
      const res = await getNonce();
      setNonce(res.data.nonce)
    }
    fetchInfomation();
  }, [])

  useEffect(() => {
    setSplit('')
    setError('')
  }, [address])
  const handleConnectWallet = async () => {
    metaMask.activate(4);
  }
  const handleDisconnectWallet = () => {
    metaMask.deactivate();
  }
  const signMessage = async () => {
    const signer = provider.getSigner(address)
    const signature = await signer.signMessage(nonce)
    const res = await getFaucetSignature({
      signature,
      nonce,
      address
    })
    if (!res.data.error) {
      setSplit(res.data.Fragment)
    } else {
      setError(res.data.error)
    }
  }

  const handleGetAirdrop = async () => {
    try {
      setLoading(true)
      await getAirdrop(address, splitResult.v, splitResult.r, splitResult.s)
      const corrected = await getIsVerified();
      setCorrect(corrected);
      setLoading(false)
    } catch (e) {
      setLoading(false)
    }
  }
  useEffect(() => {
    async function fetchCorrected() {
      const corrected = await getIsVerified();
      setCorrect(corrected);
    }
    if (provider && address) {
      fetchCorrected()
    }
  }, [address, getIsVerified, provider])
  const handleSwitchNetwork = () => {
    metaMask.activate(4)
  }
  const isNotRinkeby = chainId !== 4 && address
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        {address}
        <Box my={1}>
          {!address && <Button variant='contained' onClick={handleConnectWallet}>Connect to wallet</Button>}
        </Box>
        <Box my={1}>
          {address && <Button color="error" onClick={handleDisconnectWallet}>Disconnect wallet</Button>}
        </Box>
        <Box my={1}>
          {address && !splitResult && nonce && !conrrected && !isNotRinkeby && <Button variant='contained' color="secondary" onClick={signMessage}>Sign To Check Whitelist</Button>}
        </Box>
        {splitResult && !loading && !conrrected && !isNotRinkeby &&
          <>
            <Typography my={1} variant='body' >Get 10,000 ATH for Athena Testnet (One-time only)</Typography>
            <Box my={1}>
              <Button variant='contained' color="secondary" onClick={handleGetAirdrop}>Get Airdrop</Button>
            </Box>
          </>
        }
        {isNotRinkeby &&
          <Box>
            <Typography my={1}>Please change to Rinkeby network.</Typography>
            <Button onClick={handleSwitchNetwork}>Switch network</Button>
          </Box>
        }
        {conrrected && !isNotRinkeby &&
          <Box my={1}>
            <Typography my={1} variant='body' >You have collected 10,000 ATH. Please go to <a href="https://testnet.athenaglobal.co" >https://testnet.athenaglobal.co</a> to join the Athena Testnet.</Typography>
          </Box>
        }
        {
          loading && (
            <CircularProgress color="secondary" />
          )
        }
        {error && <Typography variant='h6'>Sorry, you are not in the whitelist. </Typography>}
      </header>
    </div >
  );
}

export default App;
